import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Typography from '../../UniformComponents/Typography'
import Button from '../../UniformComponents/Button'
import { ErrorSVG } from '../GenericError'
import Panel from '../../UniformComponents/Panel'

const STEPS = [
    'Reading your survey results',
    'Quizzing the questions',
    'Crunching responses',
    'Fine-tuning filters',
    'Arranging the slides',
]

const renderLoading = () => (
    <div className="presentations__building-card">
        <Panel cssClass="presentations__building-panel">
            <div className="presentations__building-icon" aria-hidden="true">
                <span className="presentations__building-bar" />
                <span className="presentations__building-bar" />
                <span className="presentations__building-bar" />
                <span className="presentations__building-bar" />
                <span className="presentations__building-bar" />
            </div>

            <Typography type="h2">Building your presentation</Typography>
            <Typography type="p" color="grey">Lining everything up</Typography>

            <div className="presentations__progress" aria-hidden="true">
                <div className="presentations__progress-fill" />
            </div>

            <ul className="presentations__checklist">
                {STEPS.map((label, idx) => {
                    const isActive = idx === STEPS.length - 1
                    const modifier = isActive
                        ? 'presentations__checklist-row--active'
                        : 'presentations__checklist-row--done'

                    return (
                        <li
                            key={label}
                            className={`presentations__checklist-row ${modifier}`}
                            style={{ '--step-index': idx }}
                        >
                            <span className="presentations__checklist-dot" />
                            <span className="presentations__checklist-label">{label}</span>
                            <span className="presentations__checklist-status">done</span>
                        </li>
                    )
                })}
            </ul>
        </Panel>
    </div>
)

const renderError = (message, onRetry, onBack) => (
    <div className="presentations__building-card presentations__building-card--error">
        <Panel cssClass="presentations__building-error-panel">
            <ErrorSVG />

            <Typography type="h2">Hmm, that didn&apos;t go to plan</Typography>

            <br />

            <Typography type="p" color="grey">
                We hit a snag opening this presentation. Give it another go in a moment,
                or head back and pick something else.
            </Typography>

            <br />

            {/* {message && (
                <Typography type="tiny" color="grey" cssClass="presentations__building-error-detail">
                    {`Details: ${message}`}
                </Typography>
            )} */}

            <div className="presentations__building-actions">
                {onBack && (
                    <Button
                        cssClass="regular tertiary"
                        label="Back"
                        onClick={onBack}
                    />
                )}
                {onRetry && (
                    <Button
                        cssClass="regular primary"
                        icon="fa-light fa-arrows-rotate"
                        label="Try again"
                        onClick={onRetry}
                    />
                )}
            </div>
        </Panel>
    </div>
)

const PresentationsBuilding = ({ store, onRetry, onBack }) => {
    const hasError = !!store?.buildingError

    return (
        <div>
            <div style={{ width: '100%', padding: 24, backgroundColor: 'white' }}>
                <Typography type="h2">{i18n.t('presentationbuilder')}</Typography>
            </div>

            <div className="presentations presentations--building">
                {hasError
                    ? renderError(store.buildingError, onRetry, onBack)
                    : renderLoading()}
            </div>
        </div>
    )
}

export default observer(PresentationsBuilding)
